export default "__VITE_ASSET__BwUqT2eg__"